import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Box from '../../base/Box';
import Text from '../../base/Text';

const Container = styled(Box).attrs(({ searchResult }) => ({
  align: 'center',
  justify: 'center',
  width: searchResult ? 190 : 160,
  height: 90,
  backgroundColor: searchResult ? 'lightLineDivider' : 'background',
  padding: '15px',
}))`
  box-sizing: border-box;
  border: ${({ searchResult, theme }) =>
    searchResult ? 'none' : `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: 4px;
`;

const Title = styled(Text).attrs({
  m: 0,
  color: 'primaryText',
  size: 'small',
  fontWeight: 'semibold',
})``;

const Description = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
  textAlign: 'center',
})``;

/**
 *
 * @param {string} [title] - no results title
 * @param {string} [description] - no results description
 * @param {boolean} [isSearchResult] - if this being displayed from a search result
 *
 */
export const NoResults = ({ title, description, isSearchResult }) => (
  <Container searchResult={isSearchResult}>
    <Title>{title ? title : 'No Results'}</Title>
    <Description>
      {description ? description : 'No results were found.'}
    </Description>
  </Container>
);

NoResults.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  isSearchResult: PropTypes.bool,
};

export default NoResults;
